// import React, { Fragment, useState, useEffect, useContext } from "react";
// import axios from "axios";
// import { useAlert } from "react-alert";
// import withClass from "../../../hoc/withClass";
// import errorHandler from "../../../hoc/ErrorHandler";
// import eBoardLogo from "../../../assets/images/eboard-logo.png";
// import SystemCopyright from "../../../components/UI/SystemCopyright/SystemCopyright";
// import { useDispatch } from "react-redux";
// import Credentials from "./Forms/Credentials/Credentials";
// import "./ExpiredPassword.css";
// import { Redirect } from "react-router-dom";
// import context from "../../../context/auth-context";

// const ExpiredPassword = (props) => {
//   document.body.className = "page-forgot-password layout-full";
//   const alert = useAlert();
//   const [authenticated, setAuthenticated] = useState(false);
//   const [oldPassword, setOldPassword] = useState(null);
//   const [newPassword, setNewPassword] = useState(null);
//   const [confirmPassword, setConfirmPassword] = useState(null);
//   const [error, setError] = useState(null);
//   const dispatch = useDispatch();
//   const authContext = useContext(context);

//   useEffect(() => {
//     window.$("#changePassword").modal("show");
//     return () => {};
//   }, []);

//   const changeExpiredPassword = (credentials) => {
//     if (confirmPassword === newPassword) {
//       const resetExpired = axios.patch("/auth/expired-password", {
//         username: sessionStorage.getItem("username"),
//         code: sessionStorage.getItem("code"),
//         // username:localStorage.getItem("username"),
//         // code:localStorage.getItem("code"),
//         old_password: oldPassword,
//         new_password: newPassword,
//       });
//       resetExpired
//         .then((response) => {
//           if (response) {
//             setOldPassword(null);
//             setNewPassword(null);
//             setConfirmPassword(null);
//             const data = response.data.data;
//             alert.show(response.data.message, { type: "success" });
//             dispatch({
//               type: "SIGN_IN",
//               payload: {
//                 authenticated: true,
//                 isAdmin: data.is_admin,
//                 companyCode: data.company_code,
//                 companyId: data.default_company,
//                 companyName: data.company_name,
//                 userId: data.user_id,
//                 userName: data.user_name,
//                 userEmail: data.user_email,
//                 isICT: data.is_ict,
//                 accessToken: data.access_token,
//                 tokenExpiry: data.token_expiry,
//                 tokenExpiryTminus: data.token_expiry_Tminus,
//                 refreshToken: data.refresh_token,
//                 loginLogId: data.login_audit_id,
//               },
//             });
//             setAuthenticated(true);
//             window.$("#expiredPasswordModal").modal("hide");
//             window.$(".modal-backdrop").remove();
//           }
//         })
//         .catch((err) => console.log("Error"));
//     } else {
//       setError("The New Password does not match the confirmed password");
//     }
//   };
//   const userNewPasswordInputChangeHandler = (password, isValid) => {
//     if (!isValid) return setNewPassword(null);

//     if (password.length === 0) return setNewPassword(null);

//     return setNewPassword(password);
//   };
//   const userOldPasswordInputChangeHandler = (password, isValid) => {
//     return setOldPassword(password);
//   };
//   const userConfirmPasswordInputChangeHandler = (password, isValid) => {
//     if (!isValid) return setConfirmPassword(null);

//     if (password.length === 0) return setConfirmPassword(null);

//     return setConfirmPassword(password);
//   };

//   return (
//     <Fragment>
//       {authenticated && <Redirect to="/dashboard" />} :
//       {sessionStorage.getItem("code") && sessionStorage.getItem("username") ? (
//         // {localStorage.getItem("code") && localStorage.getItem("username") ? (
//         <>
//           <div className="page-content vertical-align-middle">
//             <img
//               src={eBoardLogo}
//               alt="eBoard Logo"
//               className="img-fluid mx-auto d-block"
//               style={{ width: "200px", height: "70px" }}
//             />
//             <h2>Set New Password</h2>
//             <p>Your password has expired, kindly enter a new password</p>
//             <Fragment>
//               <Credentials
//                 changeExpiredPassword={changeExpiredPassword}
//                 userNewPasswordInputChangeHandler={
//                   userNewPasswordInputChangeHandler
//                 }
//                 userOldPasswordInputChangeHandler={
//                   userOldPasswordInputChangeHandler
//                 }
//                 userConfirmPasswordInputChangeHandler={
//                   userConfirmPasswordInputChangeHandler
//                 }
//                 oldPassword={oldPassword}
//                 newPassword={newPassword}
//                 confirmPassword={confirmPassword}
//                 error={error}
//               />
//               <SystemCopyright forgotPassword />
//             </Fragment>
//           </div>
//         </>
//       ) : (
//         <Redirect to="/" />
//       )}
//     </Fragment>
//   );
// };

// export default errorHandler(
//   withClass(ExpiredPassword, "page vertical-align text-center"),
//   axios
// );

import React, { Fragment, useState, useEffect, useContext } from "react";
import axios from "axios";
import { useAlert } from "react-alert";
import withClass from "../../../hoc/withClass";
import errorHandler from "../../../hoc/ErrorHandler";
import eBoardLogo from "../../../assets/images/eboard-logo.png";
import SystemCopyright from "../../../components/UI/SystemCopyright/SystemCopyright";
import { useDispatch } from "react-redux";
import Credentials from "./Forms/Credentials/Credentials";
import "./ExpiredPassword.css";
import { Redirect } from "react-router-dom";
import context from "../../../context/auth-context";

const ExpiredPassword = (props) => {
  document.body.className = "page-forgot-password layout-full";
  const alert = useAlert();
  const [authenticated, setAuthenticated] = useState(false);
  const [oldPassword, setOldPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const authContext = useContext(context);

  useEffect(() => {
    window.$("#changePassword").modal("show");
    return () => {};
  }, []);

  const changeExpiredPassword = (credentials) => {
    if (confirmPassword === newPassword) {
      const resetExpired = axios.patch("/auth/expired-password", {
        username: sessionStorage.getItem("username"),
        code: sessionStorage.getItem("code"),
        old_password: oldPassword,
        new_password: newPassword,
      });
      resetExpired
        .then((response) => {
          if (response) {
            setOldPassword(null);
            setNewPassword(null);
            setConfirmPassword(null);
            const data = response.data.data;
            alert.show(response.data.message, { type: "success" });
            dispatch({
              type: "SIGN_IN",
              payload: {
                authenticated: true,
                isAdmin: data.is_admin,
                companyCode: data.company_code,
                companyId: data.default_company,
                companyName: data.company_name,
                userId: data.user_id,
                userName: data.user_name,
                userEmail: data.user_email,
                isICT: data.is_ict,
                accessToken: data.access_token,
                tokenExpiry: data.token_expiry,
                tokenExpiryTminus: data.token_expiry_Tminus,
                refreshToken: data.refresh_token,
                loginLogId: data.login_audit_id,
                loginName: data.login_name
              },
            });
            setAuthenticated(true);
            window.$("#expiredPasswordModal").modal("hide");
            window.$(".modal-backdrop").remove();
          }
        })
        .catch((err) => console.log("Error"));
    } else {
      setError("The New Password does not match the confirmed password");
    }
  };
  const userNewPasswordInputChangeHandler = (password, isValid) => {
    if (!isValid) return setNewPassword(null);

    if (password.length === 0) return setNewPassword(null);

    return setNewPassword(password);
  };
  const userOldPasswordInputChangeHandler = (password, isValid) => {
    return setOldPassword(password);
  };
  const userConfirmPasswordInputChangeHandler = (password, isValid) => {
    if (!isValid) return setConfirmPassword(null);

    if (password.length === 0) return setConfirmPassword(null);

    return setConfirmPassword(password);
  };

  return (
    <Fragment>
      {authenticated && <Redirect to="/dashboard" />}:
      {sessionStorage.getItem("code") && sessionStorage.getItem("username") ? (
        <>
          <div className="page-content vertical-align-middle">
            <img
              src={eBoardLogo}
              alt="eBoard Logo"
              className="img-fluid mx-auto d-block"
              style={{ width: "200px", height: "70px" }}
            />
            <h2>Set New Password</h2>
            <p>Your password has expired, kindly enter a new password</p>
            <Fragment>
              <Credentials
                changeExpiredPassword={changeExpiredPassword}
                userNewPasswordInputChangeHandler={
                  userNewPasswordInputChangeHandler
                }
                userOldPasswordInputChangeHandler={
                  userOldPasswordInputChangeHandler
                }
                userConfirmPasswordInputChangeHandler={
                  userConfirmPasswordInputChangeHandler
                }
                oldPassword={oldPassword}
                newPassword={newPassword}
                confirmPassword={confirmPassword}
                error={error}
              />
              <SystemCopyright forgotPassword />
            </Fragment>
          </div>
        </>
      ) : (
        <Redirect to="/" />
      )}
    </Fragment>
  );
};

export default errorHandler(
  withClass(ExpiredPassword, "page vertical-align text-center"),
  axios
);
